var _mask, _mask2, _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleLimeDumbbell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon-circle-lime--dumbbell_svg__a",
    height: 37,
    maskUnits: "userSpaceOnUse",
    width: 37,
    x: 6,
    y: 7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 7h37v37H6z",
    fill: "#d9d9d9"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-circle-lime--dumbbell_svg__b",
    height: 40,
    maskUnits: "userSpaceOnUse",
    width: 41,
    x: 5,
    y: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.03 5h40v40h-40z",
    fill: "#d9d9d9"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    fill: "#e3fb94",
    r: 25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-circle-lime--dumbbell_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-circle-lime--dumbbell_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13.744 30.23a2.435 2.435 0 010-3.444l2.232-2.232c.95-.95 2.492-.95 3.442 0l6.059 6.06c.95.949.95 2.491 0 3.441l-2.233 2.232c-.95.95-2.492.95-3.442 0zm7.427-5.13l3.76 3.76 3.96-3.96-3.761-3.76zm3.414-5.713a2.435 2.435 0 010-3.442l2.232-2.232c.95-.95 2.492-.95 3.443 0l6.058 6.058c.95.95.95 2.492 0 3.443l-2.232 2.232c-.95.95-2.492.95-3.442 0z",
    fill: "#000",
    fillRule: "evenodd"
  })))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle-lime--dumbbell-ad4aab6f4b18ade374b7cb660a87b8f1.svg";
export { SvgIconCircleLimeDumbbell as Component };